export default "__VITE_ASSET__CZ6Ec1NU__"